export const PRICING_MODEL = {
  FLAT_FEE: 'flat_fee',
  PER_UNIT: 'per_unit',
  TIERED: 'tiered',
  STAIRSTEP: 'stairstep',
  VOLUME: 'volume'
};
